export const outgoing_core_team = [
    {
        imgSrc : "/assets/team/dhruv.jpg",
        name: "Dhruv Chauhan",
        designation: "Co-head, Sports Division",
        description:"A naturally versatile sports person and martial artist, Dhruv is most passionate about football, hiking and skiing. He is also a wildlife enthusiast and photographer. As a committed changemaker, he has used his robotics skills to help manual scavengers and to clean water bodies, and even summitted Mt.Kilimanjaro to fund Khel Katha initiatives!"
    },
    {
        imgSrc : "/assets/team/soham.jpg",
        name: "Soham Chauhan",
        designation: "Co-head, Vocational training",
        description:"Soham is a trained Capoerista, passionate footballer and an avid mountaineer. As a music lover, the violin is his favorite companion. Always driven towards helping society, his initiatives have taken him from building robot prototypes for BMC workers to organising rural clean up drives, and even to the roof of Africa !"
    },
    {
        imgSrc : "/assets/team/shaurya2.jpeg",
        name: "Shaurya Shah",
        designation: "Co-head, Sports Division",
        description:"Shaurya is a dynamic leader with a passion for sports, bringing years of experience in football and an extensive background in martial arts.He has also won a silver medal in world karate tournament .As a seasoned athlete, Shaurya combines discipline and strategic insight to foster growth and inclusivity in the sports programs at Khelkatha. Since taking on the role of Co-Head, Shaurya has spearheaded initiatives that emphasize skill development, teamwork, and resilience, ensuring students benefit from a holistic approach to sports training. His dedication to accessible, community-focused sports education has made a lasting impact, inspiring students to strive for excellence both on and off the field."
    },
    {
        imgSrc : "/assets/team/adya.jpg",
        name: "Adya Thanawala",
        designation: "Co-Head, Vocational Training",
        description:"Adya is an exceptional aerialist, a bronze world champion in Karate with over a decade of experience, a black belt, and a dedicated baker. Her diverse expertise makes her a well-rounded and influential leader, contributing actively to the vocational and sports initiatives at Khelkatha since 2020. As Co-Head, Adya collaborates closely with her team to build skill-building programs and develop accessible, resourceful strategies for students. Her work includes identifying easily sourced materials and crafting marketable skills, ensuring students receive a practical and empowering learning experience."
    }
]

export const team = [
    {
        name: "Shivaan Patwa"
    }, 
    {
        name: "Tyisha Golechha"
    },
    {
        name: "Vritti Tulsiyan"
    }, 
    {
        name: "Shivika Hegde"
    }, 
    {
        name: "Krisha Savla"
    }, 
    {
        name: "Awantika Chaudhry"
    }, 
    {
        name: "Jiaan Doshi"
    }
]

export const core_team = [
    {
        imgSrc : "/assets/team/srihari.jpg",
        name: "Srihari Subramanian (Head, Sports Division)",
        description:"Srihari, heading the Sports Division, is an empathetic leader and an avid competition level badminton player. He sought to inculcate professional pursuit aspirations in Khelkatha children enabling them physically and financially to take up serious sports as football, basketball and chess. Starting off in 2022, with training the municipal school children during their weekly Physical Training (PT) periods, Srihari spearheaded initiatives that emphasize skill development, physical well-being & nutrition, and co-led large-scale Mumbai inter-school Sports Days with participation from over 120 children. Elsewhere, Srihari pursues his passion for Engineering & AI, building energy efficient and sustainable engineering prototypes, researching on AI and publishing a paper in American Journal of Student Research. "
    },
    {
        imgSrc : "/assets/team/radha.jpg",
        name: "Radha Doshi (Head of Social Media & Vocational Training)",
        description:"Radha leads the Social Media and Vocational Training Divisions, using creative storytelling and practical skills to empower municipal school children. Since joining in 2021, she has developed Khelkhatha’s digital presence and designed workshops introducing children to careers in art and design,  encouraging both creative confidence and real-world skills.Teaching the municipal school children during their weekly vocational training sessions she patiently guides them through  their artistic journey,helping them explore different aspects and mediums of art . Beyond Khelkhatha, Radha is a three-time ISSO football champion and IBSO national team invitee. She currently serves as her school’s Sports Representative and is the Head of Art & Design at the International Youth Conference balancing creativity with athleticism . A trained Odissi dancer and Level 5 aerial artist, she balances leadership, sport, and the arts with equal passion. Aiming to pursuing the arts ,Radha loves experimenting with different mediums from crochet to acrylics and believes creativity has no limits. "
    },
    {
        imgSrc : "/assets/team/advait.jpg",
        name: "Advait Berde (Head of Organisation & Planning)",
        description:"Advait brings structure, foresight, and a deep sense of commitment to every project he takes on. As Head of Organisation & Planning, he's the strategist behind the scenes — turning ideas into actionable plans and ensuring that every initiative runs smoothly from start to finish. His journey with Khelkatha began in 2022, when he started training municipal school children in basic fitness and introducing them to the fundamental rules of football. What began as casual weekly sessions evolved into a structured, impact-driven program — focused on discipline, teamwork, and physical well-being. With Advait at the helm, planning and execution became seamless, allowing the program to expand sustainably. A black belt karate competitor and a passionate footballer, Advait brings an athlete’s focus and a planner’s mindset to every task. Outside of the field, he’s equally drawn to digital creation — from designing intuitive websites to building tech prototypes and capturing detail through photography. Whether it’s coordinating an event or constructing a new system, Advait works with quiet precision and a sharp eye for both people and process. "
    },

]

// export const volunteers = [
//     {
//         name: "Tia Katharani"
//     }, 
//     {
//         name: "Awantika Chaudhry"
//     },
//     {
//         name: "Tyisha Golechha"
//     }, 
//     {
//         name: "Vritti Tulsiyan"
//     }, 
//     {
//         name: "Maanasvi Rajwani"
//     }, 
//     {
//         name: "Maanasvi Rajwani"
//     }, 
//     {
//         name: "Reya Kejriwal"
//     }, 
//     {
//         name: "Krisha Savla"
//     }
// ]